<app-message-header></app-message-header>

<div class="section">

	<!-- Side nav bar -->
	<div class="inner-container">
        <!-- Loader -->
        <div class="page-loader" *ngIf="loadershow">
            <img src="assets/images/uib-loading-500x500.gif" style="width: 100px;margin-top: 110px;">
        </div>

        <!--Dropdown-->
        <label>Choose Reseller</label>
          <select class="custom-select" [(ngModel)]="selectedReseller" (change)="viewApplicationDetails()">
            <option hidden value="" disabled selected>Choose Reseller</option>
            <option *ngFor="let item of resellerList" [ngValue]="item">{{item.company}}</option>
         </select>
        
		<!-- Reseller Content -->
		<div style="padding-top: 20px;">
                <div *ngIf="connectorList && connectorList.length > 0 && !loadershow ">
                    <table mat-table [dataSource]="dataSource" style="width: 96%;" class="mat-elevation-z8" *ngIf="ELEMENT_DATA && ELEMENT_DATA.length > 0">
                        <ng-container matColumnDef="appName">
                             <th id="appl" mat-header-cell *matHeaderCellDef style="width: 150px;">Application</th>
                             <td id="applData" mat-cell *matCellDef="let element" style="width: 150px;"> 
                                 <div>
                                    <div *ngIf="element.applicationName!='Total Count'">{{element.applicationName}}</div>
                                    <div class="font-weight-bold" *ngIf="element.applicationName=='Total Count'">{{element.applicationName}}</div> 
                                     
                                 </div>
                             </td>
                         </ng-container>
                        <ng-container matColumnDef="name">
                             <th id="appl" mat-header-cell *matHeaderCellDef>Channels</th>
                             <td id="applData" mat-cell *matCellDef="let element"> 
                                 <div>
                                     {{element.name}}
                                 </div>
                             </td>
                         </ng-container>
                         <ng-container matColumnDef="renualDate">
                              <th id="appl" mat-header-cell *matHeaderCellDef>Last Renewal Date</th>
                              <td id="applData" mat-cell *matCellDef="let element"> 
                                  <div>
                                      {{element.lastRenewedAt | date : 'dd-MM-yyyy'}}
                                  </div>
                              </td>
                          </ng-container>
                         <ng-container matColumnDef="todaysMessage">    
                              <th id="appl" mat-header-cell *matHeaderCellDef>Today's Sent/Receive Messages</th>
                              <td id="applData" mat-cell *matCellDef="let element">
                                <div class="spn1">
                                    <div class="span2">                
                                        <div id="d" *ngIf="element.todaysSentMessage !=='' && element.todaysSentMessage !== null && element.todaysSentMessage !== undefined"><br/> Sx - {{element.todaysSentMessage}} <br/><br/> Rx -  {{element.todaysReceivedMessage}}</div>
                                        <img *ngIf="element.todaysSentMessage ==='' || element.todaysSentMessage === null || element.todaysSentMessage === undefined" src="assets/images/uib-loading-500x500.gif" alt="Count today's message Loader" width="25px" style="margin-top: 10px;">
                                    </div>
                                </div>
                              </td>
                          </ng-container>
                          <ng-container matColumnDef="weeklyMessage">    
                               <th id="appl" mat-header-cell *matHeaderCellDef>Current Week Sent/Receive Messages</th>
                               <td id="applData" mat-cell *matCellDef="let element">
                                <div class="spn1">
                                    <div class="span2">
                                        <div id="d" *ngIf="element.weekSentMessage !=='' && element.weekSentMessage !== null && element.weekSentMessage !== undefined"><br/> Sx - {{element.weekSentMessage}} <br/><br/> Rx -  {{element.weekReceivedMessage}}</div>
                                        <img *ngIf="element.weekSentMessage ==='' || element.weekSentMessage === null || element.weekSentMessage === undefined" src="assets/images/uib-loading-500x500.gif" alt="Count week message Loader" width="25px" style="margin-top: 10px;">
                                    </div>
                                </div> 
                               </td>
                           </ng-container>
                           <ng-container matColumnDef="monthlyMessage">    
                                <th id="appl" mat-header-cell *matHeaderCellDef>Current Month Sent/Receive Messages</th>
                                <td id="applData" mat-cell *matCellDef="let element">
                                    <div class="spn1">
                                        <div class="span2">
                                            <div id="d" *ngIf="element.monthSentMessage !=='' && element.monthSentMessage !== null && element.monthSentMessage !== undefined"><br/> Sx - {{element.monthSentMessage}} <br/><br/> Rx -  {{element.monthReceivedMessage}}</div>
                                            <img *ngIf="element.monthSentMessage ==='' || element.monthSentMessage === null || element.monthSentMessage === undefined" src="assets/images/uib-loading-500x500.gif" alt="Count month message Loader" width="25px" style="margin-top: 10px;">
                                        </div>
                                    </div> 
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="yearlyMessage">    
                                 <th id="appl" mat-header-cell *matHeaderCellDef>Current Year Sent/Receive Messages</th>
                                 <td id="applData" mat-cell *matCellDef="let element">
                                    <div class="spn1">
                                        <div class="span2">
                                            <div id="d" *ngIf="element.yearSentMessage !=='' && element.yearSentMessage !== null && element.yearSentMessage !== undefined"><br/> Sx - {{element.yearSentMessage}} <br/><br/> Rx -  {{element.yearReceivedMessage}}</div>
                                            <img *ngIf="element.yearSentMessage ==='' || element.yearSentMessage === null || element.yearSentMessage === undefined" src="assets/images/uib-loading-500x500.gif" alt="Count year message Loader" width="25px" style="margin-top: 10px;">
                                        </div>
                                    </div>
                                 </td>
                             </ng-container>
                             <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                             <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                     </table>
                     <h3 *ngIf="ELEMENT_DATA && ELEMENT_DATA.length == 0" style="margin: 50px 0 0 500px;">No records Found</h3>
                </div>
                <app-pagination *ngIf="!loadershow" [collectionSize]="paginationCount" [pageSize]="5" [(page)]="page" [maxSize]="3" [disabled]="paginationDisabled" (pageChange)="pageChanged2($event)"></app-pagination>
        </div>
    </div>
</div>
